<script setup lang="ts">
import { onUnmounted, toRefs, toValue, watch } from 'vue'

import type { ToastContext } from '@global-store/stores/toast'
import { useIntervalFn } from '@vueuse/core'

const props = defineProps<ToastContext>()

const refs = toRefs(props)

const emits = defineEmits<{
  'update:context': [ToastContext]
}>()

const onUpdate = () =>
  emits('update:context', {
    open: toValue(refs.open),
    remaining: toValue(refs.remaining),
  })

useIntervalFn(onUpdate, 1000, {
  immediate: true,
  immediateCallback: true,
})

onUnmounted(() => onUpdate)

watch(refs.open, () => onUpdate)
</script>
